// extracted by mini-css-extract-plugin
module.exports = {"tc_band_rhs":"YpQmP","tc_prime":"P7o7J","logo":"HdjWF","tc_head":"yxUr3","desc":"eLtaX","tc_cta":"xar7A"};